import { notify } from 'utils/reduxUtils';

export const types = {
  CLOSE: 'bomRestructuringDrawer/CLOSE',
  OPEN: 'bomRestructuringDrawer/OPEN',
  MOVE_NODE_DOWN_ERROR: 'bomRestructuringDrawer/MOVE_NODE_DOWN_ERROR',
  MOVE_NODE_DOWN_REQUEST: 'bomRestructuringDrawer/MOVE_NODE_DOWN_REQUEST',
  MOVE_NODE_DOWN_SUCCESS: 'bomRestructuringDrawer/MOVE_NODE_DOWN_SUCCESS',
  MOVE_NODE_UP_ERROR: 'bomRestructuringDrawer/MOVE_NODE_UP_ERROR',
  MOVE_NODE_UP_REQUEST: 'bomRestructuringDrawer/MOVE_NODE_UP_REQUEST',
  MOVE_NODE_UP_SUCCESS: 'bomRestructuringDrawer/MOVE_NODE_UP_SUCCESS',
};

export const bomRestructuringDrawer = {
  open: ({ callBack, direction, quoteItemId, nodeIds }) => ({
    type: types.OPEN,
    payload: { callBack, direction, quoteItemId, nodeIds },
  }),
  close: () => ({
    type: types.CLOSE,
  }),
};

export const moveNodeDown = {
  error: notify(
    (error) => ({
      type: types.MOVE_NODE_DOWN_ERROR,
      payload: error,
    }),
    'Failed to move node down.',
  ),
  request: ({ destinationPartUuid, nodes }) => ({
    type: types.MOVE_NODE_DOWN_REQUEST,
    payload: { destinationPartUuid, nodes },
  }),
  success: () => ({
    type: types.MOVE_NODE_DOWN_SUCCESS,
  }),
};

export const moveNodeUp = {
  error: notify(
    (error) => ({
      type: types.MOVE_NODE_UP_ERROR,
      payload: error,
    }),
    'Failed to move node up.',
  ),
  request: ({ grandParentPartUuid, parent, nodes, copyComponents }) => ({
    type: types.MOVE_NODE_UP_REQUEST,
    payload: { grandParentPartUuid, parent, nodes, copyComponents },
  }),
  success: () => ({
    type: types.MOVE_NODE_UP_SUCCESS,
  }),
};
